export const isAlphanumeric = (value: string) => /^[A-Za-z0-9]+$/.test(value);
